import Cancel from '@/assets/Cancel'
import MagGlass from '@/assets/MagGlass'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export default function TableHeader({
  setExtraFilters,
}: {
  setExtraFilters: React.Dispatch<React.SetStateAction<Record<string, any>>>
}) {
  const navigate = useNavigate()
  const [search, setSearch] = useState('')

  const handleSearch = () => {
    setExtraFilters({ search: search.trim() })
  }

  const handleClear = () => {
    setSearch('')
    setExtraFilters({})
  }

  return (
    <div className="w-full">
      <div className="grid grid-cols-10">
        <div className="col-span-5 flex relative">
          <Input
            placeholder="Buscar nombre cliente o proceso anterior"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearch()
              }
            }}
            className="w-full pr-14"
          />
          <button
            type="button"
            onClick={handleSearch}
            className="absolute right-0 top-0 h-full bg-transparent text-gray-700 border-l border-gray-300 flex items-center justify-center px-4 focus:outline-none"
            aria-label="Buscar"
          >
            <MagGlass />
          </button>

          {search.trim() !== '' && (
            <button
              onClick={handleClear}
              className="absolute right-16 top-1/2 -translate-y-1/2 flex items-center justify-center bg-gray-300 rounded-full w-4 h-4"
              aria-label="Limpiar búsqueda"
            >
              <Cancel />
            </button>
          )}
        </div>

        <div className="col-span-5 flex justify-end">
          <Button
            type="button"
            className="ml-auto text-white bg-black-1"
            onClick={() => navigate('/procesamientos/crear')}
          >
            Nuevo procesamiento
          </Button>
        </div>
      </div>
    </div>
  )
}
